import React from 'react';
import { useForm } from 'react-hook-form';
import { usePharmacy } from '../context/PharmacyContext';
import { motion } from 'framer-motion';

function MedicationReminders() {
  const { register, handleSubmit, reset } = useForm();
  const { reminders, setReminders } = usePharmacy();

  const onSubmit = (data) => {
    setReminders([...reminders, data]);
    reset();
  };

  return (
    <motion.div initial={{ x: '-100vw' }} animate={{ x: 0 }} exit={{ x: '100vw' }}>
      <h2>Medication Reminders</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        <input {...register('medication')} placeholder="Medication Name" required />
        <input {...register('time')} type="time" placeholder="Reminder Time" required />
        <button type="submit">Add Reminder</button>
      </form>
      <ul>
        {reminders.map((reminder, index) => (
          <li key={index}>{reminder.medication} at {reminder.time}</li>
        ))}
      </ul>
    </motion.div>
  );
}

export default MedicationReminders;
